import React, { useEffect, useState, useCallback, useMemo, useContext } from "react";
import PendingInvit from "../../../components/PendingInvite";
import "./style.scss";
import "../../../assets/css/main.scss";
import sorticon from "../../../assets/images/sorticon.svg";
import statusGreen from "../../../assets/images/statusGreen.svg";
import newUserWhite from "../../../assets/images/newUserWhite.svg";
import userProfileIcon from "../../../assets/images/userProfileImage.svg";
import blockIconred from "../../../assets/images/blockIconred.svg";
import {
  Row,
  Col,
  Image,
  Dropdown,
  DropdownButton,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import {
  USER,
  STORAGE_BUCKET,
  ROLE,
  TEAM,
  ROLE_PERMISSION,
} from "../../../config/endPoints";
import { useFormik } from "formik";
import closeicon from "../../../assets/images/closeicon.svg";
import addnewuser from "../../../assets/images/addnewuser.svg";
import uploadIcon from "../../../assets/images/uploadIcon.svg";
import selectarrow from "../../../assets/images/selectarrow.svg";
import checkIcon from "../../../assets/images/checkIcon.svg";
import crossuncheck from "../../../assets/images/crossuncheck.svg";
import Add from "../Modal/AddUser";
import { useNavigate, useLocation } from "react-router-dom";
import { getCroppedImg } from "../../../helpers/cropImage";
import {
  httpGet,
  httpPostFormData,
  httpPost,
  httpDelete,
  dismissToster,
  checkEffectivePermissions,
} from "../../../utils/http";
import { errorToaster, successToaster } from "../../../components/Toaster";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Delete from "../../../components/Modal/Delete";
import { tosterTime, permissionTypes, DELETE_TEAM_MEMBER, BLOCK_TEAM_USER } from "../../../config/const";
import _ from "lodash";
import {
  DEACTIVATE_ACCOUNT,
  PHONE_VALIDATION,
  TEAM_INVITATION_SUCCESS,
  UPDATE_TEAM_USER_SUCCESS,
  PENDING_INVITE_DELECTED,
} from "../../../config/generalMessage";
import Pagination from "../../../components/Pagination";
import { pageSize } from "../../../config/const";
import { ThreeSixtyOutlined } from "@material-ui/icons";
import { AppContext } from "../../../config/context";
import { planPermission } from "../../../helpers/planPermission";

function CreateTeam() {
  /**
   * Check component location
   */
  const location = useLocation();
  // console.log("location.state.selectedTeamUser.data", JSON.parse(localStorage.getItem("userDetails"))._id);
  /**
   * Initial States
   */
  const [show, setShow] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState();
  const { permissionStatus, setPermissionStatus } = useContext(AppContext);
  const [userDetail, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );
  const [teamCreatedBy, setTeamCreatedBy] = useState(
    location.state.teamDetails.createdBy
  );
  const [profilePic, setProfilePic] = useState({ preview: "", raw: "" });
  const [selectedTeam, setSelectedTeam] = useState([
    location.state.teamDetails.id,
  ]);
  const [profilePicCrop, setProfilePicCrop] = useState({
    preview: "",
    raw: "",
  });
  const [user, setUser] = useState(location.state.selectedTeamUser.data);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [roleList, setRoleList] = useState();
  const [userId, setUserId] = useState();
  const [modalType, setModalType] = useState("Add");
  const [getTeamArr, setTeamArr] = useState();
  const [showDel, setDelShow] = useState(false);
  const [profilePicture, setProfilePicture] = useState();
  const [teamList, setTeamList] = useState(location.state.teamList);
  const [selectedTeamName, setSelectedTeamName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [apiStatus, setApiStatus] = useState(false);
  const [imgSize, setImgSize] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cropper, setCropper] = useState(false);
  const [sentImage, setSentImage] = useState("");
  const [loaderStatus, showLoaderStatus] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissionData, setSelectedPermissionData] = useState({});
  const [selectPermissionClone, setSelectPermissionClone] = useState([]);
  const [permissionArr, setPermissionArr] = useState([])
  const [userPlan, setUserPlan] = useState(
    JSON.parse(localStorage.getItem("userDetails")).planPermission
  );
  const [inviteTeamList, setInviteTeamList] = useState([]);
// const [roleForTeam, setRoleForTeam] = useState("");
  /**
   * handle Crop
   */
  const handleCrop = () => {
    setCropper(!cropper);
  };
  /**
   * Move on another page
   */
  const navigate = useNavigate();
  /**
   * Open delete Modal
   */
  const DelShow = (id) => {
    setUserId(id);
    setDelShow(true);
  };
  /**
   * Close Delete Modal
   */
  const DelClose = () => setDelShow(false);

  /**verifyPermissions */
  const verifyPermissions = () => {
    let id = location.state.teamDetails.id;
    if (id) {
      let index = userDetail?.teamRolePermissions?.findIndex(
        (item) => item.teamId === id
      );
      if (index != -1)
        setSelectedPermissionData(
          userDetail.teamRolePermissions[index]?.permissionArr
        );
      setPermissionStatus(false)
    }
  };

  /**
   * delete Category by ID
   */
  const deleteUser = async () => {
    let deleteUser = await httpGet(
      `${TEAM}/deleteTeamUser/?teamId=${location.state.teamDetails.id}&userId=${userId}`
    );
    if (deleteUser?.status === 200) {
      user.splice(userId, 1);
      getTeamUsers();
      successToaster("User has been deleted seccessfully.");
      setTimeout(() => {
        toast.dismiss();
      }, tosterTime);
      setDelShow(false);
    } else {
      errorToaster(deleteUser?.data?.responseMessage);
      setTimeout(() => {
        toast.dismiss();
      }, tosterTime);
    }
  };

  /**
   * Complete Crop
   */
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  /**
   * Connected team members
   */
  const getTeamUsers = async (item) => {
    let teamId = item ? item._id : location.state.teamDetails.id;
    setSelectedTeam([item ? item._id : location.state.teamDetails.id]);
    let searchTeamUser = await httpGet(`${TEAM}/members/${teamId}`);
    if (searchTeamUser.status === 200) {
      setUser(searchTeamUser.data.data);
      setApiStatus(true);
    }
    if (item) {
      setSelectedTeamName(item.name);
    } else {
      setSelectedTeamName(location.state.teamDetails.name);
    }
  };

  /**
   * Role List
   */
  const getRoleList = async () => {
    let role = await httpGet(`${ROLE}`);
    if (role?.status === 200) {
      let filterRole = role.data.data.map((a) => ({
        value: a,
        label: a[0].toUpperCase() + a.slice(1).toLowerCase(),
      }));
      setRoleList(filterRole);
    }
  };

  /**permissionsList */
  const permissionsList = async () => {
    let role = await httpGet(`${ROLE_PERMISSION}`);
    if (role?.status === 200) {
      setPermissions(role.data.data);
    }
  };

  /**
   * open modal with preview values
   */
  const handleShow = () => {
    formik.setErrors({}, false);
    formik.setFieldValue("image", "");
    formik.setFieldValue("firstName", "");
    formik.setFieldValue("image", "");
    formik.setFieldValue("lastName", "");
    formik.setFieldValue("email", "");
    formik.setFieldValue("phone", "");
    formik.setFieldValue("company", "");
    formik.setFieldValue("role", "");
    formik.setFieldValue("teams", [...selectedTeam]);
    setProfilePic();
    setShow(true);
  };

  /**
   *
   * @returns Close Modal
   */
  const handleClose = () => {
    setShow(false);
    formik.setErrors({}, false);
    setProfilePicture("");
    setSentImage("");
    setCropper(false);
  };

  /**
   * Return back to teams
   */
  const goBack = () => {
    navigate("/teams");
  };

  /**
   * Crop image using puls button
   */
  const handleMouseUp = () => {
    setImgSize(imgSize + 0.0650000000000001);
    setZoom(imgSize + 0.0650000000000001);
  };

  /**
   * Crop image using minus button
   */
  const handleMouseDown = () => {
    setImgSize(imgSize - 0.0650000000000001);
    setZoom(imgSize - 0.0650000000000001);
  };

  /**selected permissions */
  const selectedPermissionClone = (value) => {
    // setSelectPermissionClone(value)
  }

  /**
   * Formik Initial Values
   */
  const initialValues = {
    // profilePicture: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    role: "",
    teams: [],
    permissions: [],
  };

  /*** Form Validation */
  const validate = (values) => {
    const errors = {};
    if (!_.isEmpty(values.email)) {
      values.email = values.email.trim();
    }

    // const phoneRegExp =
    //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/i.test(
    //     values.phone
    //   );

    const regexEmail = !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      values.email
    );

    // if (_.isEmpty(values.firstName)) {
    //   errors.firstName = "First Name is required";
    // }

    if (_.isEmpty(values.email)) {
      errors.email = "Email is required";
    }
    // values.teams = [...selectedTeam];
    // if (_.isEmpty(values.teams)) {
    //   errors.teams = "Team is required";
    // }

    // if (!phoneRegExp && !_.isEmpty(values.phone)) {
    //   errors.phone = PHONE_VALIDATION;
    // }
    // if (values.phone.length != 10 && !_.isEmpty(values.phone)) {
    //   errors.phone = PHONE_VALIDATION;
    // }

    if (regexEmail && !_.isEmpty(values.email)) {
      errors.email = "Invalid Email";
    }
    return errors;
  };

  /**
   * formik function for setInput values, validations,and submit function
   */
  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: async (values) => {
      let typeArrPermissions = [];
      if (selectPermissionClone.length > 0) {
        for (let value of selectPermissionClone) {
          let typeArr = value.typeArr.forEach((item) => {
            if (item.value == true) {
              typeArrPermissions.push(item)
            }
          })
        }
        values.permissions = typeArrPermissions
      }

      let clonePermissions = permissions;
      let selectedPermissionArr = [];
      if (selectPermissionClone.length == 0) {
        permissions.map((item) => {
          {
            item["typeArr"].map((innerItem, innerIndex) => {
              innerItem.value = false;
              selectedPermissionArr.push(innerItem);
            });
          }
        });

      }

      showLoaderStatus(true);
      let croppedImage = "";
      if (profilePic?.preview && croppedAreaPixels) {
        croppedImage = await getCroppedImg(
          profilePic.preview,
          croppedAreaPixels
        );
      }

      /**
       * add category API
       */
      let filedata = "";
      if (!cropper) {
        filedata = profilePic?.raw;
      } else if (cropper) {
        if (croppedImage || profilePic?.raw?.name) {
          filedata = new File([croppedImage], profilePic?.raw.name, {
            type: profilePic.raw.type,
          });
        }
      }

      const formData = new FormData();
      formData.append("email", values.email.toLocaleLowerCase());
      formData.append("role", values.role.value ? values.role.value : (values?.role?.customOption) ? values?.role?.label : values.role);
      if (selectPermissionClone.length == 0) {
        formData.append("permissions", []);
        formData.append(
          "permissionsClone",
          JSON.stringify(clonePermissions)
        );
      } else {
        formData.append("permissions", JSON.stringify(values.permissions));
        formData.append(
          "permissionsClone",
          JSON.stringify(selectPermissionClone)
        );
      }

      formData.append("teams", JSON.stringify(selectedTeam));

      if (modalType === "Add") {
        let userRes = await httpPostFormData(`${USER}`, formData);
        if (userRes?.data.responseCode === 200) {
          showLoaderStatus(false);
          setPermissionStatus(true);
          successToaster(TEAM_INVITATION_SUCCESS);
          dismissToster();
          setShow(false);
          getTeamUsers();
          // setTimeout(() => {
          //   navigate("/teams");
          // }, 3000);
        } else {
          errorToaster(userRes?.data?.responseMessage);
          showLoaderStatus(false);
          setPermissionStatus(true);
          setShow(false);
          formik.setErrors({}, false);
          setProfilePicture("");
          setSentImage("");
          setCropper(false);
          dismissToster();
        }
      }
      if (modalType === "Edit") {
        let userRes = await httpPost(`${USER}/updateUser/${userId}`, formData);
        if (userRes.status === 200) {
          successToaster(UPDATE_TEAM_USER_SUCCESS);
          showLoaderStatus(true);
          setShow(false);
          dismissToster();
          getTeamUsers();
        } else {
          errorToaster(userRes?.data?.responseMessage);
          setShow(false);
          formik.setErrors({}, false);
          setProfilePicture("");
          setSentImage("");
          setCropper(false);
        }
      }
    },
  });

  /**
   * Selected role on role change
   */
  const onRoleChange = (role, type) => {
    if (type === "keyUp") {
      if (role && role.length > 4) {
        formik.setFieldValue("role", role);
      }
    } else {
      formik.setFieldValue("role", role[0]);
    }
  };

  /**
   * Select Team
   */
  const selectTeam = (team) => {
    setSelectedTeam(team);
    // formik.setFieldValue("teams", team);
    initialValues.teams = [...selectedTeam];
  };

  /**
   * Select Permissions
   */

  const selectPermission = (selectedPermissions) => {
    let clone = [...permissions]
    if (selectedPermissions.length > 0) {
      for (let value of permissions) {
        for (let innerValue of clone) {
          if (value == innerValue) {
            innerValue.typeArr = value.typeArr
          }
        }
      }
    }
    //  else {
    //   clone = [...permissions]
    // }
    setSelectPermissionClone(clone)
  };

  // const selectPermission = (permissions) => {
  //   formik.setFieldValue("permissions", permissions);
  //   initialValues.permissions = permissions;
  // };

  // Handle fav team logo upload
  const handleChangeTeamLogo = async (e) => {
    formik.setFieldValue("profilePicture", "");
    setSentImage(URL.createObjectURL(e.target.files[0]));
    if (e.target.files.length) {
      setProfilePic({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
      e.preventDefault();
    }
  };

  const getInviteTeamList = async () => {
    let id = location.state.teamDetails.id;
    // console.log("id1111: ", id);
    let inviteRes = await httpGet(`${USER}/getInvitePendings/${id}`);
    // console.log("invite Response: ", inviteRes);
    if (inviteRes?.status === 200) {
      setInviteTeamList(inviteRes?.data?.data);
    }
  };

  const deletePendingTeam = async (id) => {
    let deleteTeamMember = await httpDelete(`${USER}/inviteMember/${id}`);
    if (deleteTeamMember?.status === 200) {
      successToaster(PENDING_INVITE_DELECTED);
      getInviteTeamList(); // Refresh the list after deletion
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    } else {
      errorToaster(deleteTeamMember?.data?.responseMessage);
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };


  /**
   * Block user
   */
  const blockUser = async (id, status) => {
    var filtered = status.find((x) => x === location.state.teamDetails.id);
    let obj = {
      userStatus: filtered ? false : true,
    };
    let blockUser = await httpPost(
      `${USER}/blockTeamUser/?teamId=${location.state.teamDetails.id}&userId=${id}`,
      obj
    );
    if (blockUser.data.responseCode === 200) {
      getTeamUsers();
      successToaster(blockUser.data.responseMessage);
      setTimeout(() => {
        toast.dismiss();
      }, tosterTime);
    }
  };

  /**
   * get Ids from the add user component
   */
  const allCheckArr = (props) => {
    setSelectedTeam(props);
  };

  /**
   * check user block status
   */
  const checkBlockStatus = (item) => {
    let check = item.find((x) => x === location.state.teamDetails.id);
    return check;
  };

  /**
   * Sort Users by asc and desc order
   */
  const sortUsers = (value) => {
    setSortOrder(value);
    if (value === "A-Z") {
      let userSort = user.sort((a, b) => {
        if (a.firstName < b.firstName) {
          return -1;
        }
        if (a.firstName > b.firstName) {
          return 1;
        }
        return 0;
      });
      setUser((data) => [...userSort]);
    }
    if (value === "Z-A") {
      let userSort = user.sort((a, b) => {
        if (a.firstName < b.firstName) {
          return 1;
        }
        if (a.firstName > b.firstName) {
          return -1;
        }
        return 0;
      });
      setUser((data) => [...userSort]);
    }
  };

  /**
   * Current Data according to pagination
   */
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return user.slice(firstPageIndex, lastPageIndex);
  }, [user, currentPage]);

  const [userStatusInTeam, setUserStatusInTeam] = useState(false)
  useEffect(() => {
    // Initial fetch to get the invite team list
    getInviteTeamList();
  }, []);
  /**
   * Function for component load
   */
  useEffect(() => {
    verifyPermissions();
    // getInviteTeamList();
    let findTeam = teamList.find(
      (item) => item._id === location.state.teamDetails.id
    );

    // setTeamId(findTeam?._id);

    let userStatus = userDetail.userDeactivateBy?.filter((item) => {
      if (item == location.state.teamDetails.id) {
        setUserStatusInTeam(true)
      } else {
        setUserStatusInTeam(false)
      }
    })

    setSelectedTeamName(findTeam?.name);
    getTeamUsers();
    getRoleList();
    permissionsList();
    
  }, [permissionStatus, selectedPermissionData]);



  return (
    <>
      <ToastContainer autoClose={1000} />
      <div className="CreateTeamWrap TeamUsersWrap">
        {userStatusInTeam ? (
          <div className="deactivateMessage">
            <h5>
              {DEACTIVATE_ACCOUNT}
            </h5>
          </div>
        ) : (
          <>
            <div className="TopWrap d-flex align-items-center justify-content-between">
              <div className="SearchWrap">
                {/* <Dropdown className="DropdownWrap m-0">
              <Dropdown.Toggle
                variant="default"
                id="timeFormat"
                className="m-0"
              >
                {selectedTeamName ? selectedTeamName : "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ margin: 0 }}>
                {teamList.map((item, index) => {
                  return (
                    <Dropdown.Item
                      style={{ margin: 0 }}
                      key={`timeFormat-${index}`}
                      onClick={() => {
                        getTeamUsers(item);
                      }}
                    >
                      {item.name}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown> */}
              </div>
              <div className="SortNewUser d-flex align-items-center">
                <div className="sortWrap">
                  <span className="SortIcon">
                    <img src={sorticon} alt="sort icon" /> Sort:
                  </span>
                  <Dropdown className="DropdownWrap m-0">
                    <Dropdown.Toggle variant="default" id="timeFormat">
                      {sortOrder ? sortOrder : "Sort"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ margin: 0 }}>
                      <Dropdown.Item onClick={() => sortUsers("A-Z")}>
                        A - Z
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => sortUsers("Z-A")}>
                        Z - A
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {((selectedPermissionData && selectedPermissionData[permissionTypes.CAN_ADD_USER]) ||
                  userDetail._id === teamCreatedBy) && (
                    <button
                      className="NewUserWrap secondaryBtn"
                      onClick={() => {
                        handleShow();
                        formik.resetForm();
                        setModalType("Add");
                      }}
                    >
                      <img src={newUserWhite} alt="" /> Add Team Member
                    </button>
                  )}
              </div>
            </div>

            <div
              aria-live="polite"
              aria-atomic="true"
              className="position-absolute tooltipnotf"
            ></div>
            <div className="TeamInnerContent">
              <h3 className="mb-5">{selectedTeamName}</h3>
              {currentTableData.length > 0 ? (
                <>
                  <Row>
                    {/* {console.log("selectedTeam: ", selectedTeam)} */}
                    {currentTableData
                      ? currentTableData.map((item, index) => {
                        
                        const matchingRoles = item.teamRolePermissions
                        ? item.teamRolePermissions.filter(roleItem => roleItem.teamId === selectedTeam[0])
                        : [];
                        
                        return (
                          <Col
                            className="mb-5"
                            lg={4}
                            xl={3}
                            md={6}
                            sm={6}
                            key={index}
                          >
                            <div className="TeamCard">
                              <div>
                                {checkBlockStatus(item.blockedBy) ? (
                                  <img
                                    className="blockUserIcon"
                                    src={blockIconred}
                                    alt="BlockUser"
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="TeamCardInner">
                                {((userDetail._id ===
                                  location.state.teamDetails.createdBy &&
                                  location.state.teamDetails.createdBy !=
                                  item._id) ||
                                  (selectedPermissionData && (selectedPermissionData[
                                    permissionTypes.DELETE_USER
                                  ] ||
                                    (selectedPermissionData[
                                      permissionTypes.BLOCK_USER
                                    ])) &&
                                    item.roleForTeam !== "Owner") && userDetail._id !== item._id) && (userDetail.email !== item?.email) && (
                                    <DropdownButton
                                      className="dotsOptions m-0"
                                      id="dropdown-basic-button"
                                    >

                                      {((userDetail._id ===
                                        location.state.teamDetails.createdBy &&
                                        location.state.teamDetails.createdBy !=
                                        item._id) || (
                                          selectedPermissionData &&
                                          selectedPermissionData[
                                          permissionTypes.DELETE_USER
                                          ])) && (
                                          <Dropdown.Item
                                            onClick={() => DelShow(item._id)}
                                            style={{ margin: 0 }}
                                            className={(userDetail.planType == 'freeTrial' || planPermission(DELETE_TEAM_MEMBER, userPlan)) ? "DeleteIcon" : "disable"}
                                          >
                                            <span className="DeleteIcon"></span>
                                            Delete
                                          </Dropdown.Item>
                                        )}


                                      {((userDetail._id ===
                                        location.state.teamDetails.createdBy &&
                                        location.state.teamDetails.createdBy !=
                                        item._id) || (selectedPermissionData &&
                                          selectedPermissionData[
                                          permissionTypes.BLOCK_USER
                                          ])) && (
                                          <Dropdown.Item
                                            style={{ margin: 0 }}
                                            href="#"
                                            onClick={() => {
                                              blockUser(item._id, item.blockedBy);
                                            }}
                                            className={(userDetail.planType == 'freeTrial' || planPermission(BLOCK_TEAM_USER, userPlan)) ? "DeleteIcon" : "disable"}
                                          >
                                            <span className="blockIcon"></span>
                                            {checkBlockStatus(item.blockedBy)
                                              ? "Unblock"
                                              : "Block"}
                                          </Dropdown.Item>
                                        )}

                                      {/* <Dropdown.Item
                                    className=""
                                    href="#"
                                    onClick={() => getUserById(item._id)}
                                  >
                                    <span className="editIcon"></span>
                                    Edit
                                  </Dropdown.Item> */}
                                    </DropdownButton>
                                  )}
                                <div className="UserImageWrap">
                                  <span
                                    className="d-inline img"
                                    style={{ position: "relative" }}
                                  >
                                    <Image
                                      src={
                                        item.profilePicture
                                          ? `${STORAGE_BUCKET}${item.profilePicture}`
                                          : userProfileIcon
                                      }
                                      alt=""
                                      roundedCircle
                                    />

                                    <span className="onlineIconWrap">
                                      <img
                                        src={statusGreen}
                                        className="onlineicon"
                                        alt="Online"
                                      />
                                    </span>
                                  </span>
                                </div>
                                <h3>{item.firstName}</h3>
                                {item.roleForTeam ? (
                                  <h3 className="teamOnwer">
                                    {item.roleForTeam}
                                  </h3>
                                ) : (
                                  ""
                                )}
                                {/* <p>{item.role}</p> */}
                                {/* <p>{matchingRoles[0].role}</p> */}
                                {matchingRoles.length > 0 ? (
                                  
                                    <p>{matchingRoles[0].role}</p>
                              
                                ) : (
                                  ""
                                )}
                                <div className="emailaddress">
                                  <p>{item.email}</p>
                                  <p>{item.phone}</p>
                                </div>
                              </div>
                              <div className="d-flex contactBtns">
                                <Button className="emailBtn" type="button">
                                  <OverlayTrigger
                                    key={"top"}
                                    placement={"top"}
                                    overlay={
                                      <Tooltip id={`tooltip-${"top"}`}>
                                        Email Functionality is not available yet
                                      </Tooltip>
                                    }
                                  >
                                    <div>
                                      <span className="emailIcon"></span> Email
                                    </div>
                                  </OverlayTrigger>
                                </Button>
                                <Button className="chatBtn" type="button">
                                  <OverlayTrigger
                                    key={"top"}
                                    placement={"top"}
                                    overlay={
                                      <Tooltip id={`tooltip-${"top"}`}>
                                        Chat Functionality is not available yet
                                      </Tooltip>
                                    }
                                  >
                                    <div>
                                      <span className="chatIcon"></span> Chat
                                    </div>
                                  </OverlayTrigger>
                                </Button>{" "}
                              </div>
                            </div>
                          </Col>
                        );
                      })
                      : ""}
                  </Row>
                  
                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={user.length}
                    pageSize={pageSize}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </>
              ) : (
                <div className="noUsers">
                  <h3>No Users</h3>
                  <Button
                    type="button"
                    className="backBtn"
                    onClick={() => goBack()}
                  >
                    Go Back
                  </Button>
                </div>
              )}

              <PendingInvit
              inviteTeamList={inviteTeamList}
              onDelete={deletePendingTeam}
              userId={JSON.parse(localStorage.getItem("userDetails"))._id}
              />
            </div>
          </>
        )}
     
      </div>

      {/* Delete Category Start */}
      <Delete
        showDel={showDel}
        DelItem={deleteUser}
        DelClose={DelClose}
        title="Do you want to delete user?"
        Desc="This will delete your user, Are you sure?"
      />

      {/* ************************************** Add User popup ********************************************** */}
      <Add
        show={show}
        handleClose={handleClose}
        addnewuser={addnewuser}
        closeicon={closeicon}
        uploadIcon={uploadIcon}
        selectarrow={selectarrow}
        checkIcon={checkIcon}
        crossuncheck={crossuncheck}
        title="Add team member"
        onSubmit={formik.handleSubmit}
        onChange={formik.handleChange}
        role={roleList}
        roleValue={formik.values.role}
        onRoleChange={onRoleChange}
        selectTeam={selectTeam}
        formik={formik}
        profilePic={profilePic}
        profilePicRaw={profilePic}
        profilePicCrop={profilePicCrop}
        crop={crop}
        zoom={zoom}
        logoValue={formik.values.profilePicture}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
        handleChangeTeamLogo={handleChangeTeamLogo}
        teamId={selectedTeam.length > 0 ? selectedTeam : []}
        getTeamArr={getTeamArr}
        profilePicture={profilePicture}
        sentImage={sentImage}
        cropper={cropper}
        handleCrop={handleCrop}
        allCheckArr={allCheckArr}
        handleMouseUp={handleMouseUp}
        handleMouseDown={handleMouseDown}
        loaderStatus={loaderStatus}
        permissions={permissions}
        permissionsList={permissionsList}
        selectPermission={selectPermission}
        permissionStatus={permissionStatus}
        selectedPermissionClone={selectedPermissionClone}
      />
    </>
  );
}
export default CreateTeam;
